module.exports = __webpack_public_path__ + "img/crm_lead_create.f0d728e6.png";